<div class="dashboard-executive-shell">
  <div class="dash-body">
    @if (loading) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
      Loading dashboard...
    </div>
}

    @if (!loading && errorMessage) {
<div class="no-data">{{ errorMessage }}</div>
}

    @if (!loading && dashboardConfig && !errorMessage) {
<div>
      @for (row of componentRows; track trackByIndex($index)) {
<div class="dash-row">
        @for (comp of row; track trackByIndex($index)) {
<div class="dash-component">
          <h4 class="comp-title">{{ comp.title }}</h4>

          @if (isChart(comp)) {
<div class="chart-placeholder">
            <i class="fa fa-bar-chart"></i> {{ comp.component_type }}
          </div>
}

          @if (isDatatable(comp)) {
<div class="dash-table-wrap">
            @if (getColumns(comp).length > 0) {
<table class="dash-table">
              <thead>
                <tr>
                  @for (col of getColumns(comp); track $index) {
<th>{{ col.title || col.data }}</th>
}
                </tr>
              </thead>
              <tbody>
                @for (dataRow of getComponentData(comp); track $index) {
<tr>
                  @for (col of getColumns(comp); track $index) {
<td>{{ getCellValue(dataRow, col) }}</td>
}
                </tr>
}
                @if (getComponentData(comp).length === 0) {
<tr>
                  <td [attr.colspan]="getColumns(comp).length" class="no-data">No data available</td>
                </tr>
}
              </tbody>
            </table>
}
            @if (getColumns(comp).length === 0 && getComponentData(comp).length > 0) {
<div class="raw-data">
              <pre>{{ getComponentData(comp) | json }}</pre>
            </div>
}
          </div>
}
        </div>
}
      </div>
}
    </div>
}

    @if (!loading && !dashboardConfig && !errorMessage) {
<div class="no-data">
      No executive dashboard data available for current filters.
    </div>
}
  </div>
</div>
